import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const FullPageGallery = (props) => {
    
    const { photos, title, toggleShowGallery } = props;

    const returnThumb = () => {
        return photos.map( photo_url => (
            <div style={{width: 50, height: 50}}>
                <img src={photo_url} alt={photo_url}/>
            </div>
        ))
    }

    return (
        <div className="full-screen-pictures-gallery" style={{display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgb(43, 52, 61)", position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh", zIndex: 10001, overflow: "hidden"}}>
            <div className="flex justify-center items-center" style={{position: "absolute", top: 0, left: 0, padding: 20, zIndex: 1, width: "100%"}}>
                <p onClick={toggleShowGallery} style={{width: 33, height: 33, display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "100%", background: "crimson", color: "white",  cursor: "pointer", zIndex: 10002, boxShadow: "1px 2px 3px rgba(0,0,0,0.33)"}}>
                <i style={{fontSize: 12}} className="fa-solid fa-times"></i></p>
                <h3 style={{marginLeft: 20, color: 'white', textShadow: "1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000" }}>
                    {title}</h3>
            </div>
            <div>
                <Carousel showThumbs={true}>
                    {
                        photos.map( photo_url => (
                            <div>
                                <img src={photo_url} alt={photo_url}/>
                            </div>
                        ))
                    }
                </Carousel>
            </div>
        </div>
    );
}

export default FullPageGallery;